import { render, staticRenderFns } from "./RequestCloseFlow.vue?vue&type=template&id=15e54f3f"
import script from "./RequestCloseFlow.vue?vue&type=script&lang=js"
export * from "./RequestCloseFlow.vue?vue&type=script&lang=js"
import style0 from "./RequestCloseFlow.vue?vue&type=style&index=0&id=15e54f3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports